var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){return _vm.toggleModal(false)}}},[_vm._v("Zavrieť")])}
var staticRenderFns = []

export { render, staticRenderFns }